import React, { ReactElement } from "react";

import { Text } from "@epignosis_llc/gnosis";

import { useApplyTranslations } from "@hooks";

import { DialogBox } from "@components/ReusableComponents";

type RefreshBrowserModal = {
  isOpen: boolean;
};

const RefreshBrowserDialog = ({ isOpen }: RefreshBrowserModal): ReactElement => {
  const { t } = useApplyTranslations();

  return (
    <DialogBox
      show={isOpen}
      title={t("refreshBrowserModal.title")}
      primaryButton={{
        text: t("refreshBrowserModal.refresh"),
        onClick: (): void => window.location.reload(),
      }}
    >
      <Text fontSize="sm" as="p">
        {t("refreshBrowserModal.heading")}
      </Text>
      <Text fontSize="sm" as="p">
        {t("refreshBrowserModal.body")}
      </Text>
    </DialogBox>
  );
};

export default RefreshBrowserDialog;
